import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { fetchLicenseStatus } from '@office-start/shell-service';
import { appsRequireLicense } from '../models/constants';
// For the scenario when users purchases the license and reaches to start page immediately, there could be chance that user's licnese info is not propagated to all the dcs
// In such case, we need to call shell service to get user's license status
export var getLicenseStatus = function (app, shellWorkloads, scenarioId) { return __awaiter(void 0, void 0, void 0, function () {
    var allWorkloads, appFromWorkload, licenseStatus;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                // Check if license is required for the app
                if (!appsRequireLicense.includes(app)) {
                    return [2 /*return*/, true];
                }
                // Check if the app already exists in the workloads
                if (shellWorkloads) {
                    allWorkloads = __spreadArray(__spreadArray([], __read(shellWorkloads.coreAndSegmentApps), false), __read(shellWorkloads.nonCoreAndSegmentApps), false);
                    appFromWorkload = allWorkloads.find(function (w) { return w.FileType === app; });
                    if (appFromWorkload) {
                        return [2 /*return*/, true];
                    }
                }
                // If app doesn't exist in workloads, get license status from shell service
                if (!scenarioId) {
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, fetchLicenseStatus(app, scenarioId)];
            case 1:
                licenseStatus = _b.sent();
                return [2 /*return*/, (_a = licenseStatus === null || licenseStatus === void 0 ? void 0 : licenseStatus.IsLicensed) !== null && _a !== void 0 ? _a : false];
        }
    });
}); };
//# sourceMappingURL=getLicenseStatus.js.map